module.exports = __webpack_public_path__ + "img/27_newYouth_wx.5959ad4b.png";